mainApp.component('slaSettingsReconnect', {
    templateUrl: '/public/components/configuration/slaSettings/sla-settings-reconnect.component.html',
    bindings: {
        site: '<?'
    },
    controller: slaSettingsReconnectController
});


function slaSettingsReconnectController($scope, $rootScope, $state, SocketUIService, UserContextService, SlaSettingService) {
    const ctrl = this;
    const MIN_SUPPORTED_MAJOR_VERSION = 12;

    ctrl.$onChanges = (changes) => {
        if (changes['site'] && ctrl.site) {
            ctrl.isEditor = UserContextService.isEditor();
            ctrl.hasSockets = ctrl.site?.deviceIds?.length > 0;
        }
    };

    ctrl.openReconnectConfirmPopUp = () => {
        const confirmMsg = "This action forces the Socket to reconnect to the preferred POP and can cause a temporary service interruption for the site. Do you want to continue?";
        const okButtonText = "Continue";
        const cancelButtonText = "Cancel";
        $rootScope.confirm(confirmMsg, ctrl.reconnect, okButtonText, cancelButtonText, null, null, null, false);
    }

    ctrl.reconnect = () => {
        if (ctrl.isEditor){
            SlaSettingService.reconnectToPreferredPop($state.params.accountId, ctrl.site.protoId, handleReconnectResponse);
        }
    };

    const handleReconnectResponse = (data) => {
        if (data?.status === 'OK')
            $scope.$root.handleServerResponse(data,'', 'The site will reconnect to preferred PoP');
        else {
            $scope.$root.handleServerResponse(data, '', '');
        }
    }

    ctrl.isDisabled = () => {
        return !ctrl.isEditor || isVersionSupported();
    }

    const isVersionSupported = () => {
        const majorVersion = ctrl.site?.socket?.version.split(".")[0] || 1;
        return MIN_SUPPORTED_MAJOR_VERSION <= majorVersion;
    }
};
